import React, { createContext } from "react";
import useBuilderData from "hooks/useBuilderData";

let BuilderDataContext;
const { Provider } = (BuilderDataContext = createContext());

const BuilderDataProvider = ({ children }) => {
  const {
    builderData,
    setBuilderData
  } = useBuilderData();

  return (
    <Provider value={{
      builderData,
      setBuilderData
    }}>
      {children}
    </Provider>
  );
};

export { BuilderDataContext, BuilderDataProvider };
